<template>
  <div class="container">
    <div class="form-group">
      <label>{{ column.label }}</label>
      <q-field  v-if="loaded">
        <q-chip
          v-if="value.label"
          closable
          color="primary"
          detail
          icon="person"
          square
          class="on-right"
          @close="handleClose"
        >
          {{ value.label }}
        </q-chip>
        <q-search
          v-else
          v-model="term"
          :stack-label="column.label"
          placeholder=""
        >
          <q-autocomplete
            placeholder=""
            @search="search"
            :min-characters="1"
            @selected="selected"
          ></q-autocomplete>
        </q-search>
      </q-field>
    </div>
  </div>
</template>
<script>
import { normalizeOption } from '../../utils/normalize'

export default {
  name: 'AutoCompleteField',
  props: {
    value: {
      type: Object,
      default: () => []
    },
    column: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      values: this.value,
      searching: false,
      loaded: false,
      term: ''
    }
  },
  computed: {
    resource () {
      return this.column.relation.namespace
    },
    labelField () {
      return this.column.relation.label
    }
  },
  methods: {
    handleClose () {
      // console.log('close??')
      this.$emit('remove', this.column.field, null, 'one')
    },
    selected (obj) {
      // console.log('>> selected', obj)
      this.term = obj.value || ''
      this.$emit('add', this.column.field, obj, 'one')
      this.$nextTick(() => {
        this.$emit('sync')
      })
    },
    async search (terms, done) {
      this.searching = true
      let results = await this.$store.dispatch(`${this.resource}/search`, {
        terms,
        options: {
          keys: [this.labelField],
          shouldSort: true
        }
      })
      this.searching = false
      return done(results.map(obj => normalizeOption(obj, this.labelField, this.column.field)))
    },
    async fetchData () {
      await this.$store.dispatch(`${this.resource}/fetchAll`, {client: this.$axios, noFilters: true})
      this.$set(this, 'loaded', true)
    }
  },
  created () {
    // this.fetchData()
  }
}
</script>
